<template>
  <div>
    <div class="wr">
      <template v-for="(item, index) in list">
        <div class="page" :key="index">
          <time>
            <span class="iconfont icon-shizhong"></span>
            {{item.created_at}}
          </time>
          <div id="box">
            <div class="box" :key="index">
              <aside class="pro">
                <span class="span1">联系人姓名：{{item.name}}</span>
              </aside>
              <aside class="pro">
                <span class="span1">联系人手机号：{{item.phone}}</span>
              </aside>
              <!-- 123 -->
              <aside class="pro" :title="item.content">
                <span @click="xx(item.id)" :class="[feedbackActive == item.id ? 'span1_active' : 'span1']">反馈内容：{{item.content}}</span>
              </aside>
              <p :title="item.reply" :class="[active_ac == item.id ? 'Leaving_actve ':'Leaving']">
                <span style="float:left;">回复：</span>
                <span>{{item.reply}}</span>
              </p>
              <div class="Expand_collapse" @click="ec_show(item.id)" v-show="item.reply && item.reply.length > 32">
                <div v-if="active_ac == item.id">︿ 收起</div>
                <div v-else>﹀ 展开</div>
              </div>
              <viewer>
                <img :src="item.thumb" :key="index" id="slt">
              </viewer>
            </div>
          </div>
        </div>
      </template>
      <!-- 分页按钮 -->

      <!-- end -->
    </div>
    <div class="pages" v-if="list.length>0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" background layout="prev, pager, next" :total="pageall"></el-pagination>
    </div>
  </div>

</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {
        length: Number,
        e: Number,
        bigImg: false,
        pageSize: 1,
        currentPage: 1,
        totalCount: 1,
        pageall: 1,
        zhankai: "展开",
        mData: [{
            time: '2019-10-14',
            shujv: [1, 2, 3, 4]
          },
          {
            time: '2019-10-14',
            shujv: [1, 2, 3, 4, 5]
          }
        ],
        num: 1019,
        list: [],
        feedbackActive: null,
        active_ac: null,
        active_ac: true
      }
    },
    methods: {
      // 123
      xx(id) {
        if (this.feedbackActive == null) {
          this.feedbackActive = id;
        } else if (this.feedbackActive == id) {
          this.feedbackActive = null
        } else {
          this.feedbackActive = id;
        }
      },
      ec_show(id) {
        if (this.active_ac == null) {
          this.active_ac = id;
        } else if (this.active_ac == id) {
          this.active_ac = null
        } else {
          this.active_ac = id;
        }
        this.acbtn_show = !this.acbtn_show;
      },

      getData(e) {

        let id = sessionStorage.id
        let _this = this
        let page = e ? e : 1
        this.$http({
            method: 'get',
            url: 'v1/soc/getfeedback?page=' + page + '&sid=' + sessionStorage.getItem("party_id"),
            data: {}
          })
          .then(res => {
            if (res.data.data.code === 200) {
              let t = this
              t.list = res.data.data.data.info


              for (var i = 0; i < t.list.length; i++) {
                // if(t.list[i].reply == null){
                //   t.list[i].reply = "暂无回复"
                // }
                var str = t.list[i].reply;
                var strs = t.list[i].content

                var widths = getSpanWidth(str);

                function getSpanWidth(str) {
                  var widths = 0;
                  var html = document.createElement('span');
                  html.innerText = str;
                  html.className = 'getTextWidths';
                  document.querySelector('body').appendChild(html);
                  widths = document.querySelector('.getTextWidths').offsetWidth;
                  document.querySelector('.getTextWidths').remove();
                  t.list[i].widths = widths

                }


              }
              t.pageall = res.data.data.data.allPage

            } else {
              _this.$message.error('请求数据有问题！')
            }
          })
          .catch(err => {
            // console.log(error);(err)
          })
      },
      sendMsgToParent() {
        this.$emit('listenToChildExen', this.num)
      },
      handleSizeChange(val) {
        this.pageNum = val
        this.getPackData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        // this.getPackData()
        this.getData(val)
      },
      getPackData() {}
    },
    created() {
      this.currentPage = Number(localStorage.getItem('pagination')) || 1
      this.handleCurrentChange(this.currentPage)
      this.getData()
    },
    mounted() {
      this.sendMsgToParent()
    }
  }

</script>

<style lang="scss" scoped>
  .open {
    text-align: right;
    margin-top: 10px;
    display: block;
    width: 75px;
    color: #666666;
    font-size: 18px;
    margin-top: 20px;
    width: 70px;
    margin-left: 740px;
    cursor: pointer;
  }

  #bigslt {
    width: 600px;
    height: 360px
  }

  #slt {
    width: 200px;
    height: 120px;
  }

  img[src=""],
  img:not([src]) {
    opacity: 0;
    display: none;

  }

  .wmassageMask {
    position: fixed;
    top: 40%;
    left: 0;
    width: 100%;
    margin: 0 auto;
    background-color: rgba(0, 0, 0, .3);
    z-index: 101;

    .zzc {
      width: 100%;
      text-align: center;
    }
  }

  .pages {
    margin-top: 34px;
    margin-right: 24px;
    height: 36px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #e60012;
    }

    /deep/ .el-icon.el-icon-arrow-left::before {
      content: '上一页';
      font-family: 'MicrosoftYaHei';
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 1px;
      color: #646464;
    }

    /deep/ .el-pagination .btn-prev {
      width: 80px;
    }

    /deep/ .el-pagination .btn-next {
      width: 80px;
    }

    /deep/ .el-icon.el-icon-arrow-right::before {
      content: '下一页';
      font-family: 'MicrosoftYaHei';
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 1px;
      color: #646464;
    }
  }

  .pro {
    margin-bottom: 10px;
    cursor: pointer;
  }


  .Expand_collapse {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 20px;
    width: 70px;
    margin-left: 740px;
    cursor: pointer;

    div {
      color: #666666;
      font-size: 18px;
    }
  }

  .wr {
    width: 934px;
    max-height: 1007px;
    background-color: #ffffff;
    box-sizing: border-box;
    padding-top: 35px;
    overflow-x: hidden;



    .page {
      margin-bottom: 60px;
      // height: 364px;
      height: auto;
      box-sizing: border-box;

      #box {
        overflow-y: scroll;
        padding-bottom: 40px;
        box-sizing: border-box;

        &::-webkit-scrollbar {
          width: 0px;
        }

        display: flex;
        justify-content: center;
        flex-wrap: wrap;
      }

      .box {
        width: 875px;
        // height: 350px;
        box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.15);
        border-radius: 5px;
        margin-top: 40px;
        padding: 31px 23px 32px 28px;
        box-sizing: border-box;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &:nth-of-type(1) {
          margin-top: 30px;
        }

        .iconfont {
          font-size: 23px;
          color: #fec300;
          position: absolute;
          right: 23px;
          top: 23px;
        }

        .Leaving {
          line-height: 30px;
          width: 100%;
          font-family: 'MicrosoftYaHei';
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #666666;
          overflow: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .Leaving_actve {
          line-height: 30px;
          width: 100%;
          font-family: 'MicrosoftYaHei';
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #666666;
          overflow: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          // white-space: nowrap;
        }

        aside {
          // width: 689px;
          // height: 23px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .span1 {
            display: inline-block;
            width: 100%;
            font-family: 'MicrosoftYaHei';
            font-size: 18px;
            line-height: 30px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
            overflow: hidden;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .span1_active {
            display: inline-block;
            width: 100%;
            font-family: 'MicrosoftYaHei';
            font-size: 18px;
            line-height: 30px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
            overflow: hidden;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            // white-space: nowrap;
          }

          .span2 {
            font-family: 'MicrosoftYaHei';
            font-size: 18px;
            font-weight: normal;
            line-height: 30px;
            letter-spacing: 1px;
            color: #999999;
          }
        }
      }

      time {
        font-family: 'MicrosoftYaHei';
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #666666;
        display: flex;
        align-items: center;
        margin-left: 30px;

        .iconfont {
          font-size: 24px;
          margin-right: 24px;
        }
      }
    }
  }

</style>
